import { createFileRoute } from '@tanstack/react-router';
import { ApiKeysTab } from '../../pages/dashboard/keys/ApiKeysTab';

export const Route = createFileRoute('/dashboard/keys/')({ component: ApiKeysTab });
